// extracted by mini-css-extract-plugin
export var link = "Technologies-module--link--0b9a5";
export var technologies = "Technologies-module--technologies--11c69";
export var technology = "Technologies-module--technology--9c0fb";